import React, { Suspense, lazy, useContext, useEffect, useState } from "react";
import { LangContext } from "../../context/AppContext";
import { api_get_ipc } from "../../api/ipc";
import { CircularProgress } from "@mui/material";

// components
const InternationalPatientCentreHeader = lazy(() =>
  import("./InternationalPatientCentreHeader")
);
const InternationalPatientCentreCarousel = lazy(() =>
  import("./InternationalPatientCentreCarousel")
);
const InternationalPatientCentreServices = lazy(() =>
  import("./InternationalPatientCentreServices")
);
const InternationalPatientApplication = lazy(() =>
  import("./InternationalPatientApplication")
);

function InternationalPatientCentreKPJ() {
  // change website description
  const _title = `International Patient Centre`;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", _title);
  // change page title
  document.title = _title;

  const { selectedLanguage } = useContext(LangContext);
  const [data, setData] = useState({
    AllData: {},
    CarouselData: {},
    IpcData: {},
    CountryData: [],
  });
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await api_get_ipc();
        if (res.status) {
          const dataFromApi = res.data[selectedLanguage];
          const { box_item, international_patient_service, country } =
            res.data[selectedLanguage];

          setData({
            AllData: dataFromApi,
            CarouselData: box_item,
            IpcData: international_patient_service,
            CountryData: country,
          });
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, [selectedLanguage]);

  useEffect(() => {
    return () => {
      // reset title and meta description
      // change website description
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", "KPJ");
      // change page title
      document.title = "KPJ";
    };
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="loading-container">
          <CircularProgress />
        </div>
      }
    >
      <InternationalPatientCentreHeader data={data.AllData} />
      <InternationalPatientCentreCarousel data={data.CarouselData} />
      <InternationalPatientCentreServices
        data={data.IpcData}
        allData={data.AllData}
      />
      <InternationalPatientApplication
        data={data.CountryData}
        allData={data.AllData}
      />
    </Suspense>
  );
}

export default InternationalPatientCentreKPJ;
